import { getRaw } from "@js/helpers/communication.js";

export const MESSAGE_TEXT_SHOW_STARTED = "MESSAGE_TEXT_SHOW_STARTED";
export const MESSAGE_TEXT_SHOW_SUCCESS = "MESSAGE_TEXT_SHOW_SUCCESS";
export const MESSAGE_TEXT_SHOW_FAILURE = "MESSAGE_TEXT_SHOW_FAILURE";
export const MESSAGE_TEXT_SHOW_ABORTED = "MESSAGE_TEXT_SHOW_ABORTED";
export const MESSAGE_TEXT_SHOW_CLOSE   = "MESSAGE_TEXT_SHOW_CLOSE";

export const messageTextShow = (messageId) => (dispatch, getState) => {
  dispatch({ type: MESSAGE_TEXT_SHOW_STARTED, messageId: messageId });

  const url = Routes.mui_message_download_path(messageId);

  getRaw(url, (data, err) => {
    // Ensure we're still looking at the same message.
    if ( getState().showMessageId !== messageId ) {
      dispatch({ type: MESSAGE_TEXT_SHOW_ABORTED });
      return;
    }

    if ( err ) {
      dispatch({ type: MESSAGE_TEXT_SHOW_FAILURE, error: err });
      return;
    }

    dispatch({ type: MESSAGE_TEXT_SHOW_SUCCESS, content: data });
  });
};

export const messageTextClose = () => ({
  type: MESSAGE_TEXT_SHOW_CLOSE,
});
